import { client } from './index';

export interface EmailCheckResult {
  exists: boolean;
  /** Only present when `exists` is true. */
  linkable?: boolean;
}

/**
 * Whether an email already belongs to a DataScope identity, and whether this
 * account may link to it.
 *
 * `exists && linkable` is the multi-account case: creation does not ask for a
 * password, because the person signs in with the credentials they already have.
 * Any other `exists` is the usual error, the email is taken.
 *
 * The server also returns a reason (`same_account`, `not_linkable`,
 * `not_enabled`). It is not modelled here because nothing reads it: telling the
 * admin which one applies is a copy decision nobody has taken yet.
 */
async function checkEmail(email: string) {
  const response = await client.get<EmailCheckResult>('/multi_account/email_check', {
    params: { email },
  });
  return response.data;
}

export const multiAccountApi = {
  checkEmail,
};
